import { Skeleton } from "@loot-os/ui/components/skeleton";

import { ErrorBanner } from "../../../components/ErrorBanner.js";
import type { BoxGridContent } from "../../pages/boxes/content/grid.js";
import { ClassicActionLink } from "../ClassicActionLink.js";
import { ClassicBoxTile } from "../ClassicBoxTile.js";

const GRID =
  "grid grid-cols-2 gap-x-2 gap-y-4 sm:grid-cols-3 md:gap-2.5 lg:grid-cols-4 xl:grid-cols-5";
const SKELETON_KEYS = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j"];

/** The design's grid: two columns on a phone, five on a wide screen. Only a phone shows its title. */
export function ClassicBoxGrid({ title, currency, state }: BoxGridContent) {
  return (
    <section className="flex flex-col gap-4">
      <h2 className="text-lg font-bold tracking-tight text-muted-foreground md:sr-only">{title}</h2>
      {state.status === "error" && <ErrorBanner>{state.message}</ErrorBanner>}
      {state.status === "loading" && (
        <div className={GRID}>
          {SKELETON_KEYS.map((key) => (
            <Skeleton key={key} className="aspect-3/5 rounded-2xl" />
          ))}
        </div>
      )}
      {state.status === "empty" && (
        <div className="flex flex-col items-start gap-3">
          <p className="text-sm text-muted-foreground">{state.message}</p>
          {state.action && <ClassicActionLink action={state.action} size="sm" />}
        </div>
      )}
      {state.status === "ready" && (
        <div className={GRID}>
          {state.tiles.map((tile) => (
            <ClassicBoxTile key={tile.box.id} tile={tile} currency={currency} />
          ))}
        </div>
      )}
    </section>
  );
}
